if (typeof window.jQuery !== "undefined") {
  (function ($) {
    $.fn.TreeSixtyImageRotate = function (options) {
      let base = this;

      let settings = $.extend({
        totalFrames: 36,
        endFrame: 36,
        currentFrame: 1,
        speed: 100,
        dragSpeed: 6,
        progress: ".spinner",
        extension: ".jpg",
        imgPrefix: "",
        navigation: true,
        spinner: true,
        imagesFolder: "images/",
        smallWidth: "auto",
        smallHeight: "auto",
        largeWidth: "auto",
        largeHeight: "auto",
        imagePlaceholderClass: "images-placeholder",
        imgList: "threesixty-images-rotate"
      }, options);

      function applyResponsiveSize() {
        let winWidth = $(window).width();

        if (winWidth > 991) {
          base.css({
            height: settings.smallHeight,
            width: settings.smallWidth,
            maxHeight: "",
            maxWidth: ""
          });
        } else {
          base.css({
            height: "",
            width: "",
            maxHeight: settings.largeHeight,
            maxWidth: settings.largeWidth
          });
        }
      }

      base.initTreeSixty = function () {
        base.css({
          position: "relative",
          margin: "auto"
        });

        applyResponsiveSize();

        if (settings.spinner) {
          base.spinner("start");
        }

        if (settings.navigation && !base.find(".navigation-bar-wrapper").length) {
          base.createNavigation();
        }

        let changeSlide = false;
        let xAxis = 0;
        let nextXAxis = 0;

        base.find(".product-media")
          .off(".tree360")
          .on("mousedown.tree360 touchstart.tree360", function (e) {
            e.preventDefault();
            xAxis = e.type === "mousedown" ? e.pageX : e.originalEvent.touches[0].pageX;
            changeSlide = true;
          })
          .on("mousemove.tree360 touchmove.tree360", function (e) {
            if (!changeSlide) return;

            nextXAxis = e.type === "mousemove" ? e.pageX : e.originalEvent.touches[0].pageX;

            if (nextXAxis > xAxis + settings.dragSpeed) {
              xAxis = nextXAxis;
              base.previous();
            } else if (nextXAxis < xAxis - settings.dragSpeed) {
              xAxis = nextXAxis;
              base.next();
            }
          })
          .on("mouseleave.tree360 mouseup.tree360 touchend.tree360", function () {
            changeSlide = false;
          });

        if (settings.spinner) {
          base.spinner("stop");
        }
      };

      base.createNavigation = function () {
        let navigationBarWrapper = $("<div/>", {
          class: "navigation-bar-wrapper"
        });

        let navigationBar = $("<div/>", {
          class: "navigation-bar"
        });

        let next = $("<div/>", {
          class: "navigation-bar-next",
          role: "button",
          tabindex: "0",
          "aria-label": "Next frame"
        });

        let previous = $("<div/>", {
          class: "navigation-bar-previous",
          role: "button",
          tabindex: "0",
          "aria-label": "Previous frame"
        });

        let playStop = $("<div/>", {
          class: "navigation-bar-play",
          role: "button",
          tabindex: "0",
          "aria-label": "Play or stop rotation"
        });

        navigationBar.append(previous, playStop, next);
        navigationBarWrapper.append(navigationBar);
        base.append(navigationBarWrapper);

        let nextInterval;
        next.on("mousedown touchstart", function (e) {
          e.preventDefault();
          nextInterval = setInterval(function () {
            base.next();
          }, settings.speed);
        }).on("mouseleave mouseup touchend", function () {
          clearInterval(nextInterval);
        });

        let previousInterval;
        previous.on("mousedown touchstart", function (e) {
          e.preventDefault();
          previousInterval = setInterval(function () {
            base.previous();
          }, settings.speed);
        }).on("mouseleave mouseup touchend", function () {
          clearInterval(previousInterval);
        });

        let play = false;
        let playStopInterval;

        playStop.on("mousedown touchstart click", function (e) {
          e.preventDefault();

          if (!play) {
            base.find(".navigation-bar-play").addClass("navigation-bar-stop");
            play = true;
            playStopInterval = setInterval(function () {
              base.next();
            }, settings.speed);
          } else {
            base.find(".navigation-bar-play").removeClass("navigation-bar-stop");
            play = false;
            clearInterval(playStopInterval);
          }
        });
      };

      base.spinner = function (status) {
        if (!base.find(".loading-spinner").length) {
          base.append($("<div/>", { class: "loading-spinner" }));
        }

        if (status === "start") {
          applyResponsiveSize();
          base.find(".loading-spinner").show();
        } else if (status === "stop") {
          base.find(".loading-spinner").hide();
        }
      };

      base.next = function () {
        let currentSlide = base.find(".active");

        if (!currentSlide.length) return;

        let imgPossition = currentSlide.data("image_number") + 1;

        if (imgPossition > settings.totalFrames) {
          imgPossition = 1;
        }

        let nextImgClass = "image-" + imgPossition;
        base.find("." + nextImgClass).addClass("active");
        currentSlide.removeClass("active");
      };

      base.previous = function () {
        let currentSlide = base.find(".active");

        if (!currentSlide.length) return;

        let imgPossition = currentSlide.data("image_number") - 1;

        if (imgPossition < 1) {
          imgPossition = settings.totalFrames;
        }

        let nextImgClass = "image-" + imgPossition;
        base.find("." + nextImgClass).addClass("active");
        currentSlide.removeClass("active");
      };

      base.toggleFullScreen = function () {
        let el = $(this)[0];
        let doc = $(document)[0];

        if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
          if (el.requestFullscreen) el.requestFullscreen();
          else if (el.msRequestFullscreen) el.msRequestFullscreen();
          else if (el.mozRequestFullScreen) el.mozRequestFullScreen();
          else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
        } else {
          if (doc.exitFullscreen) doc.exitFullscreen();
          else if (doc.msExitFullscreen) doc.msExitFullscreen();
          else if (doc.mozCancelFullScreen) doc.mozCancelFullScreen();
          else if (doc.webkitExitFullscreen) doc.webkitExitFullscreen();
        }
      };

      base.on("webkitfullscreenchange mozfullscreenchange fullscreenchange", function () {
        applyResponsiveSize();
      });

      $(window).on("resize.tree360", function () {
        applyResponsiveSize();
      });

      return base;
    };
  })(jQuery);
} else {
  console.warn("TreeSixtyImageRotate skipped because jQuery is not loaded.");
}